// Tooltip de la celda deshabilitada de C2/C3 en un día "No opera" (design
// horario-turno-dia §6). El llamador es responsable de `aria-disabled` en el
// contenedor de la celda — este componente solo aporta la explicación.
import { InfoHint } from '../../components/ui/info-hint';

export function CeldaNoOperaTooltip({ turnoNombre }: { turnoNombre: string }) {
  return (
    <InfoHint ariaLabel={`El turno ${turnoNombre} no opera este día`}>
      El turno {turnoNombre} no opera este día según el horario vigente.
    </InfoHint>
  );
}
